export const JWT = 'JWT';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SAVE_PROFILE = 'SAVE_PROFILE';
export const SAVE_PROFILE_IMAGE = 'SAVE_PROFILE_IMAGE';
export const SAVE_CURRENT_GEOLOCATION = 'SAVE_CURRENT_GEOLOCATION';
export const SAVE_CLOSEST_USERS = 'SAVE_CLOSEST_USERS';
export const UPDATE_ACTIVE_CLOSEST_USERS = 'UPDATE_ACTIVE_CLOSEST_USERS';
export const SELECT_COMMON_INTERESTS = 'SELECT_COMMON_INTERESTS';
export const UNSELECT_COMMON_INTERESTS = 'UNSELECT_COMMON_INTERESTS';
export const SAVE_FILTERED_CLOSEST_USERS = 'SAVE_FILTERED_CLOSEST_USERS';
export const SAVE_USER_INTERESTS = 'SAVE_USER_INTERESTS';
export const REMOVE_USER_INTERESTS = 'REMOVE_USER_INTERESTS';
export const SAVE_CONVERSATIONS = 'SAVE_CONVERSATIONS';
export const APPEND_NEW_CONVERSATION = 'APPEND_NEW_CONVERSATION';
export const SAVE_SELECTED_CONVERSATION = 'SAVE_SELECTED_CONVERSATION';
export const CLEAN_SELECTED_CONVERSATION = 'CLEAN_SELECTED_CONVERSATION';
export const CLEAN_ERROR_MESSAGES = 'CLEAN_ERROR_MESSAGES';
export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
export const DISPLAY_SCREEN_CONTAINER = 'DISPLAY_SCREEN_CONTAINER';